import InlineCardBreadcrumb from './InlineCardBreadcrumb';
import type { VisualFrameProps } from '../types';

/**
 * Default visual frame (assistant chat): the purple-bar breadcrumb above the
 * widget body, at natural height. This is the look every inline visual has unless
 * a surface injects a different frame (e.g. the report grid's gray tile). It is
 * deliberately the only frame the generic visuals know about — other surfaces
 * pass their own via the `Frame` prop.
 */
const AssistantVisualFrame = ({ breadcrumb, children }: VisualFrameProps) => (
    <div className="flex flex-col gap-3">
        <InlineCardBreadcrumb {...breadcrumb} />
        {children}
    </div>
);

export default AssistantVisualFrame;
